import React, { useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSectors } from '../../store/sectorSlice';
import '../../assets/scss/cmn.scss';
import '../../assets/scss/leftside.scss'
import * as MdIcons from 'react-icons/md';
import { setSelectedSuperTag } from '../../store/selectedTagSlice';
// import { FaSearch } from 'react-icons/fa';
// import axios from 'axios';
// import { BASE_URL } from 'commonConfig/ApiConfig';
const DefaultLeftSide = () => {
  const dispatch = useDispatch();
  const selectedCategory = useSelector(state => state.selectedTag.selectedSuperTag);
  const navigate = useNavigate();
  const { items: sectorItems, supertags, loading, error } = useSelector(state => state.sector);

  useEffect(() => {
    dispatch(fetchSectors());
  }, [dispatch]);

  const getSuperTagName = code => {
    const tag = supertags.find(t => t.id === code);
    return tag ? tag.name : code;
  };

  const superTagCodes = [...new Set(sectorItems.map(item => item.super_tag_code))];
  const filtered = selectedCategory === 'All'
    ? sectorItems
    : sectorItems.filter(item => item.super_tag_code === selectedCategory);

  const sectorEvent = (sector) => {
    navigate(`/sector/${sector.code}`, { state: { sector } });
  };
  // const [searchText, setSearchText] = useState("");

//   const handleSearch = async () => {
//   try {
//     const payload = { searchText: searchText };
//     console.log("Payload:", payload);

//     // const response = await axios.post(`$(base)searchAll`, payload);
//     const response = await axios.post(
//                     `${BASE_URL}indicators/searchAll`,
//                     payload
//                 );

//     if (response.data.success) {
//       // ✅ navigate only if success
//       navigate("/searchlist", { state: { results: response.data } });
//     } else {
//       alert(response.data.message || "No results found");
//     }
//   } catch (error) {
//     console.error("Search API Error:", error);
//     alert("Something went wrong while searching!");
//   }
// };

  return (
    <div className="p-3 scrollable-panel">
      {/* <p className="text-center text-md-start color-dark-blue f-14">
       An integrated platform for urban data in India, spanning national, state, district, and city levels, powered by  government datasets with cross-sectoral, spatial, and temporal data visualisation and analysis.
      </p>
     <div className="input-group mb-3">
      <input
        type="text"
        className="form-control"
        placeholder="Search Sectors and Sub-Sectors"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />
      <button className="btn btn-primary" onClick={handleSearch}>
        <FaSearch /> 
      </button>
    </div> */}
      {/* Category Badges */}
      <div className="mb-3">
        <div className="btn-group flex-wrap" role="group">
          <Badge
            bg={selectedCategory === 'All' ? 'darkv' : 'secondary'}
            onClick={() => dispatch(setSelectedSuperTag('All'))}
            className="me-2 mb-2 d-flex align-items-center gap-1"
            style={{ cursor: 'pointer' }}
          >
            {selectedCategory === 'All' && <span>✓</span>}
            See All
          </Badge>

          {superTagCodes.map(code => (
            <Badge
              key={code}
              bg={selectedCategory === code ? 'darkv' : 'secondary'}
              onClick={() => dispatch(setSelectedSuperTag(code))}
              className="me-2 mb-2 d-flex align-items-center gap-1"
              style={{ cursor: 'pointer' }}
            >
              {selectedCategory === code && <span>✓</span>}
              {getSuperTagName(code)}
            </Badge>
          ))}
        </div>
      </div>

      {/* Sector Cards */}
      <div className="row">
        {loading && <p>Loading sectors...</p>}
        {error && <p className="text-danger">Error: {error}</p>}
        {!loading && filtered.map(item => {
          const IconComponent = MdIcons[item.icon];

          return (
            <div className="col-12 col-sm-6 col-lg-4 mb-3" key={item.code}>
              <div
                className="card h-100"
                style={{ cursor: "pointer" }}
                onClick={() => sectorEvent(item)}
              >
                <div className="card-body p-2 d-flex justify-content-between align-items-center">
                  <h6 className="mb-0 text-800 color-dark-blue">{item.name}</h6>
                  {IconComponent ? <IconComponent size={28} color="#2668f7" /> : null}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Optional "Show Less" — resets category */}
      {filtered.length > 6 && selectedCategory !== 'All' && (
        <div className="text-left mt-2">
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={() => dispatch(setSelectedSuperTag('All'))}
          >
            Show Less
          </button>
        </div>
      )}
    </div>
  );
};

export default DefaultLeftSide;
